export default __webpack_public_path__ + "bluedot.70b53b72.svg";